<template>
  <div>
    <Wrapper class="max-w-3xl">
      <div class="mb-8 text-left">
        <h3 class="text-gray-600 text-lg font-bold">
          Edición de entidad emisora de valores
        </h3>
        <p class="text-gray-400 font-bold">
          Ingrese la información de la entidad emisora de valores que registrará
        </p>
      </div>
      <a-form-model layout="vertical" :model="form" class="mx-auto max-w-md">
        <!-- Nombre abreviado de la entidad -->
        <a-form-model-item label="Nombre abreviado de la entidad">
          <a-input
            v-model="form.name"
            placeholder="Ej: Banco de la républica"
          />
        </a-form-model-item>
        <!-- NIT -->
        <a-form-model-item label="NIT">
          <a-input v-model="form.nit" placeholder="NIT" />
        </a-form-model-item>
        <!-- Código de la entidad -->
        <a-form-model-item label="Código de la entidad">
          <a-input v-model="form.code" placeholder="número" />
        </a-form-model-item>
        <!-- Tipo de entidad -->
        <BaseSelect
          ref="tipo_entidad"
          id="tipo_entidad"
          label="Tipo de entidad"
          :selectOptions="formOptions.optionsEntityType"
          v-model="form.company_emisores_type"
          :value="form.company_emisores_type"
        />
        <!-- Control / Vigilado -->
        <BaseSelect
          ref="tipo_control"
          id="tipo_control"
          label="Control / Vigilado"
          :selectOptions="formOptions.optionsMannedCheckpoint"
          v-model="form.company_emisores_control"
          :value="form.company_emisores_control"
        />
        <!-- Feedback -->
        <div v-if="feedback">
          <p class="my-2 text-xs text-center text-red-500">{{ feedback }}</p>
        </div>
        <div class="w-full mt-6 flex flex-col md:flex-row gap-5">
          <a-button
            type="primary"
            @click="$router.go(-1)"
            shape="round"
            ghost
            :block="true"
            :loading="loading"
          >
            <span class="mx-2">CANCELAR</span>
          </a-button>
          <a-button
            type="primary"
            @click="createCompanyEmisora"
            shape="round"
            :block="true"
            :loading="loading"
          >
            <span class="mx-2">GUARDAR</span>
          </a-button>
        </div>
      </a-form-model>
    </Wrapper>
  </div>
</template>

<script>
import Wrapper from "../../UI/Wrapper";
import companiesEmisoraService from "@/feature/dashboard/companies-emisores/data/services/companies_emisores_services_impl";
export default {
  // ModalResponseMassive
  components: { Wrapper },
  data() {
    return {
      loading: false,
      feedback: "",
      form: {
        name: "",
        nit: "",
        code: "",
        company_emisores_type: "",
        company_emisores_control: "",
      },
    };
  },
  methods: {
    async createCompanyEmisora() {
      if (!this.checkForm()) return;

      let { data, error } = await companiesEmisoraService.createCompanyEmisores(
        this.form
      );

      if (error) this.showToast("error", "Error creando la entidad.");

      if (data) {
        if (data.error) {
          this.showToast("error", data.error);
          this.$router.push(`/dashboard/companies-emisoras`);
          return;
        }

        this.showToast(
          "success",
          "Entidad emisora de valores creada exitosamente."
        );
        this.$router.push(`/dashboard/companies-emisoras`);
        return;
      }
    },
    checkForm() {
      this.feedback = null;

      if (this.$validator.isEmpty(this.form.name)) {
        this.feedback = "Introduzca el nombre de la entidad.";
        return false;
      }
      if (this.$validator.isEmpty(this.form.nit + "")) {
        this.feedback = "Introduzca el número NIT";
        return false;
      }
      // Validar formato del NIT: solo números con un guion opcional entre bloques
      const nitPattern = /^\d+(-\d+)?$/;
      if (!nitPattern.test(this.form.nit)) {
        this.feedback =
          "El NIT solo puede contener números y opcionalmente un guion entre dos bloques de números (Ejemplos: 123456789 o 12345678-9)";
        return false;
      }
      if (this.$validator.isEmpty(this.form.code)) {
        this.feedback = "Introduzca un número para el código de la entidad.";
        return false;
      }
      // Validar que el código solo contenga números enteros
      const codePattern = /^\d+$/;
      if (!codePattern.test(this.form.code)) {
        this.feedback =
          "El código de la entidad solo puede contener números enteros.";
        return false;
      }
      if (this.$validator.isEmpty(this.form.company_emisores_type + "")) {
        this.feedback = "Seleccione el tipo de la entidad.";
        return false;
      }
      if (this.$validator.isEmpty(this.form.company_emisores_control + "")) {
        this.feedback = "Seleccione el tipo de control / vigilado";
        return false;
      }
      return true;
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    toggleModal(val) {
      this.showModal = false;
      this.$router.go(-1);
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>
